var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.cte
    ? _c("div", [
        _c("div", { staticClass: "box" }, [
          _c("div", { staticClass: "columns" }, [
            _c(
              "div",
              { staticClass: "column is-4 sc-pre-invoice-detail-ctes__width" },
              [
                _c(
                  "article",
                  { staticClass: "panel" },
                  [
                    _c(
                      "p",
                      {
                        staticClass:
                          "panel-heading has-text-primary has-text-weight-bold"
                      },
                      [_vm._v("\n            Dados fiscais\n          ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "sc-grid-layout",
                      { attrs: { columns: 1 } },
                      [
                        _c(
                          "sc-grid-item",
                          {
                            class: {
                              "sc-cte-global": _vm.cte.invoice_list.length > 1
                            }
                          },
                          [
                            _c("b", [_vm._v("Número do Pedido:")]),
                            _vm._v(" "),
                            _vm._l(_vm.cte.invoice_list, function(so) {
                              return _c("div", [
                                _c(
                                  "p",
                                  {
                                    staticClass:
                                      "sc-pre-invoice-detail-ctes__grid-item"
                                  },
                                  [
                                    _c(
                                      "a",
                                      {
                                        attrs: {
                                          href:
                                            "/ng#/order-number/" +
                                            so.order_number
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(so.order_number) +
                                            "\n                  "
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ])
                            })
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c(
                          "sc-grid-item",
                          {
                            class: {
                              "sc-cte-global": _vm.cte.invoice_list.length > 1
                            }
                          },
                          [
                            _c("b", [_vm._v("Código de rastreio:")]),
                            _vm._v(" "),
                            _vm._l(_vm.cte.invoice_list, function(so) {
                              return _c("div", [
                                _c(
                                  "p",
                                  {
                                    staticClass:
                                      "sc-pre-invoice-detail-ctes__grid-item"
                                  },
                                  [
                                    _c(
                                      "a",
                                      {
                                        attrs: {
                                          href:
                                            "http://status-testing.intelipost.com.br/tracking/" +
                                            so.tracking_code,
                                          target: "_blank"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(so.tracking_code) +
                                            "\n                  "
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ])
                            })
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c(
                          "sc-grid-item",
                          {
                            class: {
                              "sc-cte-global": _vm.cte.invoice_list.length > 1
                            }
                          },
                          [
                            _c("b", [
                              _vm._v(
                                _vm._s(
                                  _vm.getInvoiceLabel(
                                    _vm.cte.invoice_list[0].invoice
                                  )
                                )
                              )
                            ]),
                            _vm._v(" "),
                            _vm._l(_vm.cte.invoice_list, function(so) {
                              return _c("div", [
                                _c(
                                  "p",
                                  {
                                    staticClass:
                                      "sc-pre-invoice-detail-ctes__grid-item"
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          _vm.getInvoiceIdentifier(so.invoice)
                                        ) +
                                        "\n                "
                                    )
                                  ]
                                )
                              ])
                            })
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c("sc-grid-item", [
                          _c("b", [_vm._v("Valor dos produtos:")]),
                          _vm._v(" "),
                          _c(
                            "p",
                            {
                              staticClass:
                                "sc-pre-invoice-detail-ctes__grid-item"
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm._f("currency")(
                                      _vm.getSumOfInvoiceCost(
                                        _vm.cte.invoice_list,
                                        "products_value"
                                      )
                                    )
                                  ) +
                                  "\n              "
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "sc-grid-item",
                          {
                            staticClass:
                              "sc-pre-invoice-detail-ctes__border-radius"
                          },
                          [
                            _c("b", [
                              _vm._v(
                                "Valor da " +
                                  _vm._s(
                                    _vm.getInvoiceLabel(
                                      _vm.cte.invoice_list[0].invoice
                                    )
                                  ) +
                                  ":"
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "p",
                              {
                                staticClass:
                                  "sc-pre-invoice-detail-ctes__grid-item"
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm._f("currency")(
                                        _vm.getSumOfInvoiceCost(
                                          _vm.cte.invoice_list,
                                          "total_value"
                                        )
                                      )
                                    ) +
                                    "\n              "
                                )
                              ]
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "box" }, [
          _c(
            "div",
            { staticClass: "sc-pre-invoice-detail-ctes" },
            _vm._l(_vm.cte.cte_list, function(cte) {
              return _c("div", { key: cte.cte_type.value }, [
                _c(
                  "article",
                  { staticClass: "panel sc-pre-invoice-detail-ctes__article" },
                  [
                    _c(
                      "p",
                      {
                        staticClass:
                          "panel-heading has-text-primary sc-pre-invoice-detail-ctes__heading"
                      },
                      [
                        cte.cte_type && cte.cte_type.label
                          ? [
                              _vm._v(
                                "\n              " +
                                  _vm._s(cte.cte_type.label) +
                                  "\n            "
                              )
                            ]
                          : [
                              _vm._v(
                                "\n              Não informado\n            "
                              )
                            ]
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "sc-grid-layout",
                      { attrs: { columns: 2 } },
                      [
                        _c("sc-grid-item", [
                          _c("b", [_vm._v("Número do Cte:")]),
                          _vm._v(" "),
                          _c(
                            "p",
                            {
                              staticClass:
                                "sc-pre-invoice-detail-ctes__grid-item"
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(cte.infos_cte.number) +
                                  "\n              "
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("sc-grid-item", [
                          _c("b", [_vm._v("Série:")]),
                          _vm._v(" "),
                          _c(
                            "p",
                            {
                              staticClass:
                                "sc-pre-invoice-detail-ctes__grid-item"
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(cte.infos_cte.serie) +
                                  "\n              "
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("sc-grid-item", [
                          _c("b", [_vm._v("Chave:")]),
                          _vm._v(" "),
                          _c(
                            "p",
                            {
                              staticClass:
                                "sc-pre-invoice-detail-ctes__grid-item"
                            },
                            [
                              _vm._v(
                                "\n               " +
                                  _vm._s(cte.infos_cte.key) +
                                  "\n              "
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("sc-grid-item", [
                          _c("b", [_vm._v("Protocolo:")]),
                          _vm._v(" "),
                          _c(
                            "p",
                            {
                              staticClass:
                                "sc-pre-invoice-detail-ctes__grid-item"
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(cte.infos_cte.protocol_number) +
                                  "\n              "
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("sc-grid-item", [
                          _c("b", [_vm._v("Data da Emissão:")]),
                          _vm._v(" "),
                          _c(
                            "p",
                            {
                              staticClass:
                                "sc-pre-invoice-detail-ctes__grid-item"
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm._f("date")(
                                      cte.infos_cte.issue_date,
                                      "DD/MM/YYYY"
                                    )
                                  ) +
                                  "\n              "
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("sc-grid-item", [
                          _c("b", [_vm._v("Data de Validação na Sefaz:")]),
                          _vm._v(" "),
                          _c(
                            "p",
                            {
                              staticClass:
                                "sc-pre-invoice-detail-ctes__grid-item"
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm._f("date")(
                                      cte.infos_cte.sefaz_validation_date,
                                      "DD/MM/YYYY"
                                    )
                                  ) +
                                  "\n              "
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("sc-grid-item", [
                          _c("b", [_vm._v("Cód. Status na Sefaz:")]),
                          _vm._v(" "),
                          _c(
                            "p",
                            {
                              staticClass:
                                "sc-pre-invoice-detail-ctes__grid-item"
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(cte.infos_cte.status_sefaz_code) +
                                  "\n              "
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("sc-grid-item", [
                          _c("b", [_vm._v("Status na Sefaz:")]),
                          _vm._v(" "),
                          _c(
                            "p",
                            {
                              staticClass:
                                "sc-pre-invoice-detail-ctes__grid-item",
                              class: _vm.getClassByStatusSefaz(cte.infos_cte)
                            },
                            [
                              cte.infos_cte.status_sefaz &&
                              cte.infos_cte.status_sefaz.label
                                ? [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          cte.infos_cte.status_sefaz.label
                                        ) +
                                        "\n                "
                                    )
                                  ]
                                : [
                                    _vm._v(
                                      "\n                  Não informado\n                "
                                    )
                                  ]
                            ],
                            2
                          )
                        ]),
                        _vm._v(" "),
                        _c("sc-grid-item", [
                          _c("b", [_vm._v("Origem do arquivo:")]),
                          _vm._v(" "),
                          _c(
                            "p",
                            {
                              staticClass:
                                "sc-pre-invoice-detail-ctes__grid-item"
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(cte.infos_cte.file_origin) +
                                  "\n              "
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("sc-grid-item", [
                          _c("b", [_vm._v("Nome do arquivo:")]),
                          _vm._v(" "),
                          _c(
                            "p",
                            {
                              staticClass:
                                "sc-pre-invoice-detail-ctes__grid-item"
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(cte.infos_cte.file_name) +
                                  "\n              "
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("sc-grid-item", [
                          _c("b", [_vm._v("Situação:")]),
                          _vm._v(" "),
                          _c(
                            "p",
                            {
                              staticClass:
                                "sc-pre-invoice-detail-ctes__grid-item"
                            },
                            [
                              cte.infos_cte.status_cte &&
                              cte.infos_cte.status_cte.label
                                ? [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(cte.infos_cte.status_cte.label) +
                                        "\n                "
                                    )
                                  ]
                                : [
                                    _vm._v(
                                      "\n                  Não informado\n                "
                                    )
                                  ]
                            ],
                            2
                          )
                        ]),
                        _vm._v(" "),
                        _c("sc-grid-item", [
                          _c("b", [_vm._v("Data da Validação:")]),
                          _vm._v(" "),
                          _c(
                            "p",
                            {
                              staticClass:
                                "sc-pre-invoice-detail-ctes__grid-item"
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm._f("date")(
                                      cte.infos_cte.validation_date,
                                      "DD/MM/YYYY"
                                    )
                                  ) +
                                  "\n              "
                              )
                            ]
                          )
                        ])
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            })
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "sc-form__footer page-pre-invoice-detail__box-footer"
            },
            [
              _c(
                "div",
                { staticClass: "column has-text-right" },
                [
                  _c(
                    "sc-button",
                    {
                      on: {
                        click: function($event) {
                          _vm.$emit("back")
                        }
                      }
                    },
                    [_vm._v(" Voltar ")]
                  )
                ],
                1
              )
            ]
          )
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-262cfcd9", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-262cfcd9","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./node_modules/@intelipost-modules/secure-recon/features/pre-invoice-detail/components/sc-pre-invoice-detail-ctes/ScPreInvoiceDetailCtes.vue
// module id = null
// module chunks = 